module.exports = __webpack_public_path__ + "static/media/block.2e90afa1.svg";